/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'

const NotificationDetailSkeleton: React.FC = () => (
  <div css={pageStyle}>
    <div css={cardStyle}>
      <div css={[shimmer, logoStyle]} />
      <div
        css={[
          shimmer,
          lineStyle,
          css`
            width: 70%;
            height: 28px;
          `,
        ]}
      />
      <div
        css={[
          shimmer,
          lineStyle,
          css`
            width: 90%;
          `,
        ]}
      />
      <div
        css={[
          shimmer,
          lineStyle,
          css`
            width: 80%;
          `,
        ]}
      />
      <div css={buttonRowStyle}>
        <div css={[shimmer, buttonStyle]} />
        <div css={[shimmer, buttonStyle]} />
      </div>
    </div>
  </div>
)

export default NotificationDetailSkeleton

// Matches NotificationDetailContent's pageStyle so the card doesn't jump
// position when data lands.
const pageStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 56px);
  padding: 48px 16px;
`

// Same geometry as the real card so there is no layout jump when data lands.
const cardStyle = css`
  display: flex;
  width: 600px;
  padding: 40px 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  border: 1px solid ${colors.SECONDARY_300};
  background: ${colors.SECONDARY_400};

  @media (max-width: 768px) {
    max-width: 100vw;
    min-width: 0;
    width: 100%;
  }
`

const shimmer = css`
  background-color: ${colors.SECONDARY_200};
  opacity: 0.6;
  border-radius: 4px;
`

const logoStyle = css`
  width: 96px;
  height: 96px;
  border-radius: 50%;
`

const lineStyle = css`
  height: 16px;
  width: 100%;
`

const buttonRowStyle = css`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
  flex-direction: column;

  @media (min-width: 480px) {
    flex-direction: row;
  }
`

const buttonStyle = css`
  height: 48px;
  flex: 1;
  border-radius: 8px;
`
